import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Portal from '../../../components/pages/auth/Portal';
import {Session as actionmodule} from '../../../actions/index';
const {actions} = actionmodule;



function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    login: actions.loginUser
  }, dispatch);
}



function mapStateToProps(state) {
  const {session, io} = state;

  return {
    session,
    io
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(Portal);



// WEBPACK FOOTER //
// ./src/containers/pages/auth/Portal.js